<div class="ds-breadcrumbs">
  @for (breadcrumb of breadcrumbsSg(); track $index; let last = $last) {
    <div class="ds-breadcrumbs__breadcrumb">
      <!-- NOTE: (click) must return `true` for `routerLink` to behave properly
      -->
      <a
        [routerLink]="breadcrumb.url"
        [class.ds-breadcrumbs__breadcrumb--clickable]="!!breadcrumb.url"
        [class.ds-breadcrumbs__breadcrumb--unclickable]="!breadcrumb.url"
        (click)="breadcrumb.callback?.(); (true)"
      >
        {{ breadcrumb.name }}
      </a>
      @if (!last) {
        <span>&nbsp;/&nbsp;</span>
      }
    </div>
  }
</div>
